// routes
// utils
import axios from 'src/utils/axios';
const STORAGE_KEY = 'accessToken'; 
// ----------------------------------------------------------------------
function jwtDecode(token) {
  if (!token) {
    throw new Error("Token is undefined or null");
  }

  const tokenParts = token.split('.');
  if (tokenParts.length !== 3) {
    throw new Error("Invalid token format");
  }

  const base64Url = tokenParts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}


export const isValidToken = (accessToken) => {
  try {
    if (!accessToken) {
      return false;
    }
    

    const decoded = jwtDecode(accessToken);
    console.log(decoded);

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return false;
  }
};


// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem(STORAGE_KEY, accessToken);  // Store in localStorage using STORAGE_KEY
    console.log("accessToken =", accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when the token is expired
    // const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    // tokenExpired(exp);
  } else {
    // localStorage.removeItem(STORAGE_KEY); 
    console.log("06"+ localStorage.removeItem(STORAGE_KEY) )
    // Remove the token from localStorage

    delete axios.defaults.headers.common.Authorization;
  }
};
